module.exports = __webpack_public_path__ + "static/media/trip-3.ce7e1cb8.png";